import { Component, ElementRef, Input, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import { Output, EventEmitter } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
// declare var swal: any;


@Component({
  selector: 'app-recorder',
  templateUrl: './recorder.component.html',
  styleUrls: ['./recorder.component.css']
})
export class RecorderComponent implements OnInit, OnChanges {
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('audio') audioRef!: ElementRef<HTMLAudioElement>;

  recorder: any;
  stream: MediaStream | null = null;
  isVideo!: boolean;
  recordingStarted = false;
  recordingStopped = false;
  timerDisplay = '00:00';
  private seconds = 0;
  private timerInterval: any;
  hideFunctions: boolean = false;

  recordedBlobUrl: string | null = null;
  recordedBlob: Blob | null = null;
  downloadFilename: string = '';
  maxCapInSeconds: any;
  ResetRecording: boolean = false;
  isPaused = false;
  private autoStopTimeout: any;
  elapsedSeconds: number = 0;
  recordingStartTime: number = 0;
  pauseAccumulatedTime: number = 0;
  pauseStartTime: number = 0;
  autoStopChecker: any;
  extraSecondAdded = false;
  mediaDuration: number | null = null;
  autoStopModal: boolean = false;




  objectKeys = Object.keys;
  @Input() surveyDetail: any;
  @Input() nextButton: string;
  @Input() setData: any;
  @Input() resetRecordingVar: boolean = false;
  @Input() stopRecordingVar: boolean = false;
  @Output() recordingCompleted = new EventEmitter<FormData>();
  @Output() recordedUrl = new EventEmitter<string>();
  @Output() ResetOff = new EventEmitter<boolean>();
  @Output() stopRecord = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.initializeFromSurvey();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['surveyDetail']) {
      this.recordedBlobUrl = null;
      this.initializeFromSurvey();
    }
    if (changes['resetRecordingVar'] && !changes['resetRecordingVar'].firstChange) {
      if (!this.resetRecordingVar) {
        this.ResetRecording = false;
      }
    }
    if (changes['stopRecordingVar'] && !changes['stopRecordingVar'].firstChange) {
      if (!this.stopRecordingVar) {
        this.recordingStarted = false;
      }
    }
  }

  private initializeFromSurvey(): void {
    const qType = this.surveyDetail?.qType;
    this.maxCapInSeconds = this.surveyDetail?.["MAX-SELECTION"]
    if (qType === 'audio-question') {
      this.isVideo = false;
    } else if (qType === 'video-question') {
      this.isVideo = true;
    }
  }




  async startRecording() {
    this.hideFunctions = true;
    this.recordingStarted = true;
    this.ResetRecording = false;
    this.recordingStopped = false;
    this.recordedBlobUrl = null;
    this.seconds = 0;
    this.timerDisplay = '00:00';
    this.pauseAccumulatedTime = 0;
    this.pauseStartTime = null;
    this.extraSecondAdded = false;
    this.isPaused = false;

    this.stream = await navigator.mediaDevices.getUserMedia(
      this.isVideo
        ? {
          video: {
            width: { exact: 160 },
            height: { exact: 120 },
            frameRate: { exact: 5 },
            facingMode: 'user'
          },
          audio: true
        }
        : {
          audio: true,
          video: false // Explicitly disable video for audio-only questions
        }
    );


    const options: RecordRTC.Options = {
      type: this.isVideo ? 'video' : 'audio',
      mimeType: this.isVideo ? 'video/webm;codecs=vp8' : 'audio/wav'
    };

    this.recorder = new RecordRTC(this.stream, options);
    this.recorder.startRecording();

    if (this.isVideo) {
      this.videoRef.nativeElement.srcObject = this.stream;
      this.videoRef.nativeElement.muted = true;
      this.videoRef.nativeElement.play();
    }

    this.startTimer();
    this.recordingStartTime = Date.now();
    this.autoStopChecker = setInterval(() => {
      const currentPause = this.isPaused && this.pauseStartTime
        ? Date.now() - this.pauseStartTime
        : 0;

      const elapsedMs = Date.now() - this.recordingStartTime - this.pauseAccumulatedTime - currentPause;
      const elapsedSec = Math.floor(elapsedMs / 1000);

      if (elapsedSec >= this.maxCapInSeconds) {
        clearInterval(this.autoStopChecker);
        // Allow UI to render the final second before stopping
        setTimeout(() => {
          this.autoStopModal = true;
          this.stopAutoRecording();
        }, 100);
      }
    }, 1000);


  }

  // async startRecording() {
  //   this.hideFunctions = true;
  //   this.recordingStarted = true;
  //   this.ResetRecording = false;
  //   this.recordingStopped = false;
  //   this.recordedBlobUrl = null;
  //   this.seconds = 0;
  //   this.timerDisplay = '00:00';
  //   this.pauseAccumulatedTime = 0;
  //   this.pauseStartTime = null;
  //   this.extraSecondAdded = false;
  //   this.isPaused = false;

  //   try {
  //     if (this.isVideo) {
  //       // Check if video input is available and request permission
  //       const devices = await navigator.mediaDevices.enumerateDevices();
  //       const hasVideoInput = devices.some(d => d.kind === 'videoinput');

  //       if (!hasVideoInput) {
  //         alert('No camera found on this device.');
  //         return;
  //       }

  //       this.stream = await navigator.mediaDevices.getUserMedia({
  //         video: {
  //           width: { exact: 160 },
  //           height: { exact: 120 },
  //           frameRate: { exact: 5 },
  //           facingMode: 'user'
  //         },
  //         audio: true
  //       });
  //     } else {
  //       this.stream = await navigator.mediaDevices.getUserMedia({
  //         audio: true,
  //         video: false
  //       });
  //     }
  //   } catch (err) {
  //     console.error('Media access error:', err);
  //     alert('Please allow access to camera and microphone for video recording.');
  //     return;
  //   }

  //   const options: RecordRTC.Options = {
  //     type: this.isVideo ? 'video' : 'audio',
  //     mimeType: this.isVideo ? 'video/webm;codecs=vp8' : 'audio/wav'
  //   };

  //   this.recorder = new RecordRTC(this.stream, options);
  //   this.recorder.startRecording();

  //   if (this.isVideo) {
  //     this.videoRef.nativeElement.srcObject = this.stream;
  //     this.videoRef.nativeElement.muted = true;
  //     this.videoRef.nativeElement.play();
  //   }

  //   this.startTimer();
  //   this.recordingStartTime = Date.now();
  //   this.autoStopChecker = setInterval(() => {
  //     const currentPause = this.isPaused && this.pauseStartTime
  //       ? Date.now() - this.pauseStartTime
  //       : 0;

  //     const elapsedMs = Date.now() - this.recordingStartTime - this.pauseAccumulatedTime - currentPause;
  //     const elapsedSec = Math.floor(elapsedMs / 1000);

  //     if (elapsedSec >= this.maxCapInSeconds) {
  //       clearInterval(this.autoStopChecker);
  //       setTimeout(() => {
  //         this.autoStopModal = true;
  //         this.stopAutoRecording();
  //       }, 100);
  //     }
  //   }, 1000);
  // }






  pauseRecording() {
    if (this.isPaused) return; // prevent duplicate pause

    this.recorder.pauseRecording();
    this.pauseTimer();
    this.pauseStartTime = Date.now();
    this.isPaused = true;
  }
  resumeRecording() {
    if (!this.isPaused) return; // prevent duplicate resume

    this.recorder.resumeRecording();
    this.startTimer();

    if (this.pauseStartTime) {
      this.pauseAccumulatedTime += Date.now() - this.pauseStartTime;
      this.pauseStartTime = null;
    }

    this.isPaused = false;

    if (!this.extraSecondAdded) {
      // this.maxCapInSeconds += 1;
      this.extraSecondAdded = true;
    }
  }




  closeAutoStopModal() {
    this.autoStopModal = false;
  }


  stopRecording() {
    this.hideFunctions = true;
    this.ResetRecording = true;

    // Clear auto-stop timeout if it was set
    if (this.autoStopTimeout) {
      clearTimeout(this.autoStopTimeout);
      this.autoStopTimeout = null;
    }

    return new Promise<void>((resolve) => {
      this.recorder.stopRecording(() => {
        this.recordingStopped = true;
        this.recordingStarted = false;

        this.recordedBlob = this.recorder.getBlob();

        if (!this.recordedBlob) {
          resolve();
          return;
        }

        const extension = this.isVideo ? 'webm' : 'wav';
        const filename = `recording_${Date.now()}.${extension}`;

        this.recordedBlobUrl = URL.createObjectURL(this.recordedBlob);

        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }

        clearInterval(this.timerInterval);
        clearInterval(this.autoStopChecker);
        // Set preview
        if (this.isVideo && this.videoRef?.nativeElement) {
          const video = this.videoRef.nativeElement;
          video.srcObject = null;
          video.src = this.recordedBlobUrl;
          video.muted = false;
          video.controls = true;
          // video.play();
        } else if (!this.isVideo && this.audioRef?.nativeElement) {
          const audio = this.audioRef.nativeElement;
          audio.src = this.recordedBlobUrl;
        }

        // Create FormData and emit event
        const formData = new FormData();
        formData.append('file', this.recordedBlob, filename);
        this.recordingCompleted.emit(formData);
        this.recordedUrl.emit(this.recordedBlobUrl);
        this.ResetOff.emit(this.ResetRecording);
        this.stopRecord.emit(this.recordingStarted);
        resolve();
      });
    });
  }


  stopAutoRecording() {
    this.hideFunctions = true;
    this.ResetRecording = true;

    // Clear auto-stop timeout if it was set
    if (this.autoStopTimeout) {
      clearTimeout(this.autoStopTimeout);
      this.autoStopTimeout = null;
    }

    return new Promise<void>((resolve) => {
      this.recorder.stopRecording(() => {
        this.recordingStopped = true;
        // this.recordingStarted = false;

        this.recordedBlob = this.recorder.getBlob();

        if (!this.recordedBlob) {
          resolve();
          return;
        }

        const extension = this.isVideo ? 'webm' : 'wav';
        const filename = `recording_${Date.now()}.${extension}`;

        this.recordedBlobUrl = URL.createObjectURL(this.recordedBlob);

        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }

        clearInterval(this.timerInterval);
        clearInterval(this.autoStopChecker);

        // Set preview
        if (this.isVideo && this.videoRef?.nativeElement) {
          const video = this.videoRef.nativeElement;
          video.srcObject = null;
          video.src = this.recordedBlobUrl;
          video.muted = false;
          video.controls = true;
          // video.play();
        } else if (!this.isVideo && this.audioRef?.nativeElement) {
          const audio = this.audioRef.nativeElement;
          audio.src = this.recordedBlobUrl;
        }

        // Create FormData and emit event
        const formData = new FormData();
        formData.append('file', this.recordedBlob, filename);
        this.recordingCompleted.emit(formData);
        this.recordedUrl.emit(this.recordedBlobUrl);
        this.ResetOff.emit(this.ResetRecording);
        this.stopRecord.emit(this.recordingStarted);
        resolve();
      });
    });
  }


  startTimer() {
    this.hideFunctions = false;

    // Clear previous timer to prevent stacking intervals
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      const currentPause = this.isPaused && this.pauseStartTime
        ? Date.now() - this.pauseStartTime
        : 0;

      const elapsed = Math.floor(
        (Date.now() - this.recordingStartTime - this.pauseAccumulatedTime - currentPause) / 1000
      );

      this.seconds = elapsed;

      const mins = String(Math.floor(elapsed / 60)).padStart(2, '0');
      const secs = String(elapsed % 60).padStart(2, '0');
      this.timerDisplay = `${mins}:${secs}`;
    }, 1000);
  }


  pauseTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }


  downloadRecording() {
    if (!this.recordedBlob) return;
    const a = document.createElement('a');
    a.href = this.recordedBlobUrl!;
    a.download = this.downloadFilename;
    a.click();
  }

  resetRecording() {
    this.recordingStarted = false;
    this.recordingStopped = false;
    this.recordedBlob = null;
    this.ResetRecording = false;
    this.recordedBlobUrl = null;
    this.recordedUrl.emit(this.recordedBlobUrl);
    this.ResetOff.emit(this.ResetRecording);
    this.stopRecord.emit(this.recordingStarted);
    this.videoRef.nativeElement.src = '';
    this.audioRef.nativeElement.src = '';
    this.hideFunctions = false;
    this.seconds = 0;
    this.timerDisplay = '00:00';

  }

  onLoadedMetadata(media: HTMLMediaElement) {
    if (isFinite(media.duration)) {
      this.mediaDuration = Math.round(media.duration);
    } else {
      const originalTime = media.currentTime;
      media.currentTime = 1e9;
      media.ontimeupdate = () => {
        media.ontimeupdate = null;
        if (isFinite(media.duration)) {
          this.mediaDuration = Math.round(media.duration);
        }
        media.currentTime = originalTime;
      };
    }
  }
  hasNonEmptyValue(data: any): boolean {
    if (!data) return false;
    return Object.values(data).some(val => val);
  }

  isAllValuesEmpty(data: any): boolean {
    if (!data) return true;
    return Object.values(data).every(val => !val);
  }

}
